import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import BackArrowIcon from "../../../common/Icons/BackArrowIcon";
import EditIcon from "../../../common/Icons/EditIcon";
import ThreeDButton from "../ThreeDButton";
import withStyles from "@material-ui/core/styles/withStyles";
import {editPathSelector, goBack} from "../../ducks/product";
import withErrorBoundary from "../../../../decorators/withErrorBoundary";

import styles from "./navigation.module.scss";

const materialStyles = {
  iconButton: {
    padding: 0
  }
};

function Navigation(props) {
  const {classes, editPath} = props;
  return (
    <div className={styles.root}>
      <div className={styles.back}>
        <IconButton classes={{root: classes.iconButton}} onClick={props.goBack}>
          <BackArrowIcon />
        </IconButton>
      </div>
      <ThreeDButton />
      <div className={styles.edit}>
        <IconButton classes={{root: classes.iconButton}} href={editPath}>
          <EditIcon />
        </IconButton>
      </div>
    </div>
  );
}

Navigation.propTypes = {
  classes: PropTypes.object,
  editPath: PropTypes.string,
  goBack: PropTypes.func
};

const mapStateToProps = (state) => ({
  editPath: editPathSelector(state)
});

export default withStyles(materialStyles)(
  connect(mapStateToProps, {
    goBack
  })(withErrorBoundary(Navigation))
);
